import api from '@/api/api'
import router from '@/router/index'

export default {
  namespaced: true,
  state: {
    politicaPrivacidad: ''
  },
  mutations: {
    set (state, payload) {
      state.politicaPrivacidad = payload
    }
  },
  actions: {
    load ({ commit, dispatch }) { // Carga las variables de configuracion
      return new Promise((resolve, reject) => {
        api.get('/configuracion/get_politica_privacidad')
          .then(response => {
            if (response.data.result.ok) {
              commit('set', response.data.result.data.data.politicaPrivacidad)
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
    // set ({ commit, dispatch }, obj) { // Carga las variables de configuracion
    //   return new Promise((resolve, reject) => {
    //     api.post('/configuracion/set_politica_privacidad', {
    //       jsondata: JSON.stringify({
    //         parametros: {
    //           politicaPrivacidad: obj
    //         }
    //       })
    //     })
    //       .then(response => {
    //         if (response.data.result.ok) {
    //           commit('set', response.data.result.data.data)
    //           resolve()
    //         } else {
    //           switch (response.data.result.code) {
    //             case 1:
    //               dispatch('alerts/addNotLoggedIn', null, { root: true })
    //               router.push({ name: 'login' })
    //               break
    //           }
    //           reject(response.data.result)
    //         }
    //       })
    //       .catch(e => {
    //         reject(e)
    //       })
    //   })
    // }
  },
  getters: {
    get (state) {
      return state.politicaPrivacidad
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/configuracion/politicaPrivacidad/store.js